import { render, staticRenderFns } from "./SelectorPendenciaLogins.vue?vue&type=template&id=946e5b6a&scoped=true"
import script from "./SelectorPendenciaLogins.vue?vue&type=script&lang=js"
export * from "./SelectorPendenciaLogins.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "946e5b6a",
  null
  
)

export default component.exports